// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2037u","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1kaBn"};